module.exports = __webpack_public_path__ + "static/img/416.356acc5b.jpg";